import { Coin } from "./Coin";

export interface Grade{
    coin: string;
    timestamp: number;
    key?: string;

    isStock?: boolean;

    //In the future, we can import these as a Price object, and serialize it
    marketCap: number;
    totalSupply?: number;
    circulatingSupply?: number;
    price: number;

    analysis: string; //An anaysis of recent performance and outlook

    //Performance
    oneMonthPerformanceUSD: number;
    oneMonthPerformanceSAT?: number;
    threeMonthPerfomanceUSD: number;
    threeMonthPerfmanceSAT?: number;

    //Stock specific
    sector?: string;
    averageVolume?: number;
    priceEarningsRatio?: number;
    dividendYeildRatio?: number;
    fiftyTwoWeekHigh?: number;
    fiftyTwoWeekLow?: number;

    //Grades
    overall: string;
    events: string;
    // possible: ['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C', 'C-', 'D+', 'D', 'D-', 'F'];
    growth: number; //1-10;
    utility: number; //1-10;
    buyRating: number; //1-10;
    risk: number; //1-10;
    volatility: number; //1-10;
}

export function newGrade(isStock: boolean): Grade{
    let grade: Grade = {
        coin: null,
        timestamp: null,
        key: null,

        isStock,

        //In the future, we can import these as a Price object, and serialize it
        marketCap: 0,
        price: 0,
        analysis: '', //An anaysis of recent performance and outlook
    
        //Performance
        oneMonthPerformanceUSD: 0,
        threeMonthPerfomanceUSD: 0,
    
        //Grades
        overall: '',
        events: '',
        // possible: ['A+', 'A', 'A-', 'B+', 'B', 'B-', 'C+', 'C', 'C-', 'D+', 'D', 'D-', 'F'];
        growth: null, //1-10;
        utility: null, //1-10;
        buyRating: null,
        risk: null, //1-10;
        volatility: null //1-10;
    }
    
    if(!isStock){
        grade.oneMonthPerformanceSAT = 0;
        grade.threeMonthPerfmanceSAT = 0;
        grade.totalSupply = 0;
        grade.circulatingSupply = 0;
    }else{
        grade.sector = '';
        grade.averageVolume = 0;
        grade.priceEarningsRatio = 0;
        grade.dividendYeildRatio = 0;
        grade.fiftyTwoWeekHigh = 0;
        grade.fiftyTwoWeekLow = 0;
    }
    return grade;
}


// WEBPACK FOOTER //
// ./src/models/Grade.ts